"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isUndefined = require('lodash/isUndefined');

var componentDefaults = require('./componentDefaults');
/**
 * @module
 * @name ShineImpositions
 */


var Impositions = function ShineImpositions() {
  var _instance;

  function init(opts) {
    var options = opts;
    /**
         * gets the bleed, orientation, length, cutCode, size, weight, queue, etc.
         * @function
         * @member
         * @name getComponentDefaults
         * @param {Product} product
         * @param {Component} component
         * @example
         * const defaultsForComponent = ShineImpositions.instance().getComponentDefaults(product, component);
         */

    function getComponentDefaults(product, component) {
      var userOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (isUndefined(product)) {
        throw new Error('getComponentDefaults requires a parent product');
      }

      if (isUndefined(component)) {
        throw new Error('getComponentDefaults requires a component');
      }

      return componentDefaults(product, component, userOpts, options);
    }
    /**
         * @function
         * @member
         * @name getDesignNames
         * @example
         * ShineImpositions.instance().getDesignNames();
         */


    function getDesignNames() {
      return 'todo';
    }
    /**
         * @function
         * @member
         * @name getPaperTypes
         * @example
         * ShineImpositions.instance().getPaperTypes();
         */


    function getPaperTypes() {
      return 'todo';
    }
    /**
         * @function
         * @member
         * @name getProductCategories
         * @example
         * ShineImpositions.instance().getProductCategories();
         */


    function getProductCategories() {
      return 'todo';
    }
    /**
         * Applies the default impositions to a product, unless that value already exists.
         * (A value already specified will not be overwritten.
         * E.g. A product should have no imposition values by default,
         * but if a value needs to be specified by a user, that value
         * should already be assigned before running this function.)
         * @function
         * @param {Product} product
         * @name applyToProduct
         * @example
         * const product = ShineProducts.instance().classicInvitationSuite.make();
         * ShineImpositions.instance().applyToProduct(product);
         *
         * @example
         * const product = ShineProducts.instance().classicInvitationSuite.make();
         * product.defaults();
         *
         * product.invitations.at(0).bleed = 'some val';
         * ShineImpositions.instance().applyToProduct(product);
         * product.invitations.at(0).bleed; // => 'some val'
         * product.invitations.at(0).orientation; // => 'P' (default)
         *
         * @example
         * const product = ShineProducts.instance().classicInvitationSuite.make();
         * product.defaults();
         *
         * product.invitations.at(0).bleed = 'some val';
         * ShineImpositions.instance().applyToProduct(product, { override: true });
         * product.invitations.at(0).bleed; // => 'n'
         * product.invitations.at(0).orientation; // => 'P' (default)
         */


    function applyToProduct(product) {
      var userOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      product.components.forEach(function (component) {
        var impositions = componentDefaults(product, component, userOpts, options);
        Object.keys(impositions).forEach(function (key) {
          if (!component[key] || userOpts.override) {
            Object.assign(component, _defineProperty({}, key, impositions[key] || 'n/a'));
          }
        });
      });
    }

    function updateOptions(newOptions) {
      options = newOptions;
    }

    return {
      updateOptions: updateOptions,
      applyToProduct: applyToProduct,
      getComponentDefaults: getComponentDefaults,
      getDesignNames: getDesignNames,
      getPaperTypes: getPaperTypes,
      getProductCategories: getProductCategories
    };
  }

  return {
    /**
         * initialize
         * @param {*} opts
         * @instance
         * @example
         * import { ShineImpositions } from 'shine-products-v2';
         * ShineImpositions.initialize(opts);
         */
    initialize: function initialize(opts) {
      _instance = init(opts);
    },

    /**
         * SINGLETON INSTANCE
         * @instance
         * @example
         * import { ShineImpositions } from 'shine-products-v2';
         * ShineImpositions.instance()
         * // => {
         * //   getComponentDefaults,
         * //   getDesignNames,
         * //   getPaperTypes,
         * //   getProductCategories,
         * // }
         */
    instance: function instance() {
      if (!_instance) {
        throw new Error('You must first initialize');
      }

      return _instance;
    }
  };
}();

module.exports = Impositions;